import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

const imageBox = css`
  width: ${rem(120)};
  margin: ${rem(16)} auto;
  & > img {
    width: 100%;
  }
`

const textArea = css`
  max-width: 100%;
`

export const styles = {
  imageBox,
  textArea,
}
